import React from 'react';
import { FormsyDate } from 'formsy-material-ui/lib';
import moment from 'moment';
import DatePickerWrapper from './DatePickerWrapper';
import globals from '../../../globals/communityGlobals';

const clearIconStyle = {
  // fontSize: '2.2rem',
  cursor: 'pointer',
  position: 'absolute',
  left: '-30px',
  top: '12px',
};
const buttonStyle = { position: 'absolute', width: '0', top: 0, right: 0 };

class ClearableFormsyDate extends FormsyDate {
  getRequiredError = () => {
    const { isRequired, isPristine, isValid, isFormSubmitted } = this;
    return isRequired() && !isPristine() && !isValid() && isFormSubmitted() ? this.props.requiredError : null;
  };
  handleDateClear = () => {
    this.setValue(undefined);
    this.handleChange();
  };
  formatDate = date => moment(date).format(globals.dateFormats.short);
  render() {
    const {
      defaultDate,
      validations,
      validationErrors,
      validationError,
      requiredError,
      className,
      disabled,
      disableClear = false,
      minDate = moment()
        .subtract(150, 'year')
        .toDate(),
      maxDate = moment()
        .add(100, 'year')
        .toDate(),
      ...rest
    } = this.props;
    const value = this.getValue();
    const isDisabled = this.isFormDisabled() || disabled;
    const errorText = this.getErrorMessage() || this.getRequiredError();
    return (
      <div className={className}>
        <DatePickerWrapper
          className="FormsyDatepicker"
          disabled={isDisabled}
          formatDate={this.formatDate}
          minDate={minDate}
          maxDate={maxDate}
          {...rest}
          errorText={errorText}
          onChange={this.handleChange}
          ref={this.setMuiComponentAndMaybeFocus}
          value={value}
        />
        {!isDisabled && !disableClear && value && (
          <span style={buttonStyle}>
            <i
              tabIndex={0}
              role="button"
              className="allocateIcons"
              style={clearIconStyle}
              onClick={this.handleDateClear}
            >
              &#xE14C;
            </i>
          </span>
        )}
      </div>
    );
  }
}

export default ClearableFormsyDate;
